import React from 'react';

export const CounterCell = ({ value }: { value: number }) => {
  return (
    <div className="flex h-10 w-full items-center justify-center">
      <span className="inline-flex h-5 min-w-6 items-center justify-center rounded-md bg-muted px-1 text-[11px] font-medium text-muted-foreground tabular-nums dark:bg-white/10">
        {value}
      </span>
    </div>
  );
};
